import { Component, OnInit } from '@angular/core';
import { TotalSystemsService } from './total-systems.service';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';

@Component({
    selector: 'app-total-systems',
    imports: [],
    templateUrl: './total-systems.html',
    styleUrl: './total-systems.scss'
})
export class TotalSystems {

    constructor(
        public themeService: CustomizerSettingsService,
        private totalSystemsService: TotalSystemsService
    ) { }

    ngAfterViewInit(): void {
        this.totalSystemsService.loadChart();
    }

    ngOnDestroy(): void {
        this.totalSystemsService.destroyChart();
    }

}